// Экранирует ASCII-пунктуацию, значимую для markdown-it, обратным слэшем,
// чтобы пользовательский текст показывался буква в букву, а не интерпретировался
// как разметка (курсив, жирный, код, ссылки и т.п.).
export function escapeMarkdown(value: string) {
  return value.replace(/[\\`*_{}[\]()#+\-.!>~|<]/g, '\\$&');
}
